import {
  Button,
  Dialog,
  DialogContent,
  AppBar,
  Toolbar,
  IconButton,
  Slide,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { rem } from "assets/js/common";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.scss";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { goLink } from "assets/js/common";
import { Cookies } from "react-cookie";
import { loadHideAlert, loadLinkAlert } from "redux/reducers/top";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  fresh: {
    "& .visual-img": {
      "& img": {
        width: "100%",
        objectFit: "cover",
      },
    },
    "& .shinsun-info": {
      padding: `${rem(60)} ${rem(20)} `,
      "& .shinsun-text": {
        textAlign: "center",
        paddingBottom: rem(20),
        "& .logo": {
          height: rem(90),
          "& img": {
            width: "auto",
            height: "100%",
          },
        },
        "& strong": {
          display: "inline-block",
          margin: `${rem(12)} 0 ${rem(24)}`,
          lineHeight: rem(18),
        },
        "& p": {
          fontSize: rem(14),
          lineHeight: rem(22),
          "& + p": {
            marginTop: rem(10),
          },
        },
      },
      "& .shinsun-list": {
        paddingTop: rem(50),

        "& strong": {
          display: "block",
          fontSize: rem(18),
          fontWeight: 700,
          color: theme.palette.primary.main,
          lineHeight: rem(24),
          margin: `${rem(30)} 0 ${rem(10)}`,
        },
        "& p": {
          fontSize: rem(14),
          lineHeight: rem(22),
        },
        "&.left": {
          float: "left",
          "& strong, p": {
            paddingLeft: rem(20),
          },
        },
        "&.right": {
          float: "right",
        },
        "&.center": {
          clear: "both",
          width: rem(323),
          margin: "0 auto",
          "& strong, p": {
            paddingLeft: rem(20),
          },
        },
        "&:after": {
          content: "''",
          display: "block",
          clear: "both",
        },
      },
    },
    "& .shinsun-intro": {
      "& h2": {
        fontSize: rem(22),
        fontWeight: 700,
        lineHeight: rem(28),
        textAlign: "center",
        "& span": {
          display: "block",
          fontSize: rem(14),
          fontWeight: 400,
          lineHeight: rem(18),
          color: theme.palette.info.main,
          marginBottom: rem(4),
          letterSpacing: "-0.2px",
        },
      },
      "&.history": {
        padding: `${rem(60)} ${rem(40)}`,
        background: theme.palette.background.default,
        "& ul": {
          position: "relative",
          marginTop: rem(40),
          "& li": {
            position: "relative",
            padding: `${rem(11)} 0 ${rem(11)} ${rem(21)}`,
            fontSize: rem(14),
            lineHeight: rem(22),
            "& b": {
              display: "inline-block",
              fontSize: rem(16),
              width: rem(56),
              fontWeight: 800,
              lineHeight: rem(24),
              letterSpacing: "-0.2px",
              verticalAlign: "middle",
            },
            "&:before": {
              content: "''",
              width: rem(4),
              height: rem(4),
              borderRadius: rem(4),
              background: theme.palette.primary.main,
              position: "absolute",
              left: 0,
              top: "50%",
              zIndex: 1,
              marginTop: rem(-2),
            },
          },
          "&:after": {
            content: "''",
            width: rem(1),
            background: theme.palette.grey[100],
            position: "absolute",
            left: rem(1),
            top: "22px",
            bottom: "22px",
          },
        },
      },
      "&.product": {
        padding: `${rem(60)} 0 ${rem(60)}`,
        position: "relative",
        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        "& .mySwiper": {
          paddingBottom: 0,
          marginTop: rem(40),
        },
        "& .item": {
          width: "100%",
          paddingBottom: 0,
          marginLeft: 0,
          alignItems: "center",
          boxSizing: "border-box",
          "& .item-img": {
            position: "relative",
            width: "100%",
            paddingTop: "100%",
            background: theme.palette.background.default,
            borderRadius: rem(10),
            "& .img-wrap": {
              position: "absolute",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              margin: "auto",
              maxWidth: "85%",
              maxHeight: "85%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "& img": {
                maxWidth: "100%",
                maxHeight: "100%",
              },
            },
          },
        },
        "& .btn-wrap": {
          marginTop: rem(40),
          padding: `0 ${rem(30)}`,
          "& a, button": {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: rem(54),
            borderRadius: rem(10),
            fontWeight: 700,
            fontSize: rem(16),
            border: `1px solid ${theme.palette.primary.main}`,
            textDecoration: "none",
            color: theme.palette.primary.main,
          },
        },
      },
    },
    "& + .MuiModal-root": {
      "& .MuiDialog-container": {
        "transition-duration": "0s !important",
      },
    },
  },
}));

export default function DrawerFresh(props) {
  const { open, handleClose } = props;
  const { data, loading } = useSelector((state) => state.home);
  const [productList, setProductList] = useState([]);
  const classes = useStyles();
  const dispatch = useDispatch();

  let cookies = new Cookies();

  let favInfo = cookies.get("favInfo");

  const storeCode = favInfo
    ? favInfo.visibleTp === "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";

  useEffect(() => {
    if (data.productList) setProductList(data.productList.list);
  }, [data]);

  const handleFav = (item) => {
    if (token) {
      axios
        .post("/api/eh/product/favorite/fav", {
          seq: item.seq,
        })
        .then((res) => {
          dispatch(
            loadMainAction({
              schTp: favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1,
              schStore: storeCode,
            })
          );
        });
    } else {
      dispatch(loadAlert(true));
    }
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      className={classes.fresh}
    >
      <AppBar>
        <Toolbar>
          <h2 className="h2">신선도원</h2>
          <IconButton
            aria-label="close"
            className="btn-close"
            onClick={handleClose}
          >
            <span className="hidden">닫기</span>
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <div className="visual-img">
          <img src={`${process.env.PUBLIC_URL}/images/img/fresh-top.png`} />
        </div>
        <div className="shinsun-info">
          <div className="shinsun-text">
            <div className="logo">
              {/* <img
                src={`${process.env.PUBLIC_URL}/images/img/shinsun-logo.svg`}
              /> */}
              <img
                src={`${process.env.PUBLIC_URL}/images/img/shinsun-logo.png`}
              />
            </div>
            <strong>신선하고 엄격한 품질관리</strong>
            <p>
              기분 좋은 식생활.
              <br />
              재료부터 다른 메가마트 자주 브랜드!
            </p>
            <p>
              고객님의 건강하고 맛있는 한 끼를
              <br />
              함께 고민하고 제안합니다.
            </p>
          </div>
          <div className="shinsun-list left">
            <img src={`${process.env.PUBLIC_URL}/images/img/fresh-m01.png`} />
            <strong>맛을 찾다!</strong>
            <p>
              나와 가족을 위한 폭 넓은 선택!
              <br />
              다양한 맛의 즐거운 경험을 선사합니다.
            </p>
          </div>
          <div className="shinsun-list right">
            <img src={`${process.env.PUBLIC_URL}/images/img/fresh-m02.png`} />
            <strong>맛을 높이다!</strong>
            <p>
              검증된 식재료와 수준 높은 중소기업과의 협업
              <br />
              재료 선별부터 생산, 유통까지 엄격하게 관리합니다.
            </p>
          </div>
          <div className="shinsun-list center">
            <img src={`${process.env.PUBLIC_URL}/images/img/fresh-m03.png`} />
            <strong>맛을 즐기다!</strong>
            <p>
              나와 가족을 위해 기꺼이 선택하는 자신감 있는 브랜드!
              <br />
              건강하고 맛있는 한 끼 식탁을 책임집니다.
            </p>
          </div>
        </div>
        <div className="shinsun-intro history">
          <h2>
            <span>History</span>
            신선도원의 역사
          </h2>
          <ul className="year">
            <li>
              <b>2006</b>브랜드 론칭
            </li>
            <li>
              <b>2016</b>신선연구소 (맛 평가단) 운영
            </li>
            <li>
              <b>2018</b>이노베이션 센터
            </li>
            <li>
              <b>2020</b>PLMA PB어워드 과자 부문수상
            </li>
            <li>
              <b>2021</b>PLMA PB어워드 2년 연속 수상
            </li>
          </ul>
        </div>
        <div className="shinsun-intro product">
          <h2>
            <span>Product</span>
            다양한 신선도원 식품
          </h2>
          <Swiper
            spaceBetween={15}
            slidesPerView={2.35}
            slidesOffsetBefore={30}
            slidesOffsetAfter={30}
            className="mySwiper"
          >
            {/* {productList.map((item, i) => (
              <SwiperSlide key={`prop-${i}`}>
                <div
                  className="item"
                  onClick={() => {
                    history.push({
                      pathname: `/product-of-week/detail/${item.seq}`,
                      props: {
                        seq: item.seq,
                      },
                    });
                  }}
                >
                  <div className="item-img">
                    <div className="img-wrap">
                      <img src={item.prodImgUrl} />
                    </div>
                  </div>
                </div>
              </SwiperSlide> */}
            <SwiperSlide>
              <div className="item">
                <div className="item-img">
                  <div className="img-wrap">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/img/fresh01.png`}
                    />
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="item">
                <div className="item-img">
                  <div className="img-wrap">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/img/fresh02.png`}
                    />
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="item">
                <div className="item-img">
                  <div className="img-wrap">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/img/fresh03.png`}
                    />
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="item">
                <div className="item-img">
                  <div className="img-wrap">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/img/fresh04.png`}
                    />
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="item">
                <div className="item-img">
                  <div className="img-wrap">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/img/fresh05.png`}
                    />
                  </div>
                </div>
              </div>
            </SwiperSlide>
            {/* ))} */}
          </Swiper>
          <div className="btn-wrap">
            <Link
              // to={{ pathname: "https://www.megamart.com/exhibition/1900055" }}
              // target="_blank"
              className="link-outlined btn-rounded"
              onClick={(e) => {
                e.preventDefault();
                dispatch(
                  loadLinkAlert("https://www.megamart.com/exhibition/1900055")
                );
                // dispatch(loadHideAlert(true));
              }}
            >
              신선도원 상품 더보기
            </Link>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
